import './root.sass';

import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setLocale } from 'react-redux-i18n';

import Router from 'containers/Router';
import SplashScreen from 'containers/splash-screen/SplashScreen';
import LoginModal from 'components/login/modal/LoginModal';

import request from 'actions/request';
import transmit from 'actions/transmit';
import redirect from 'actions/redirect';
import normalizeLocale from 'helpers/locale';

class Root extends Component {
  componentWillMount() {
    if (this.props.userPending !== false) {
      this.props.request(
        ['users', 'get'],
        'get',
        'USER',
      ).then((resp) => {
        if (resp.login === null) {
          this.props.redirect('/', true);
        } else {
          this.props.transmit(null, setLocale(normalizeLocale(resp.lang)),  true);
        }
      });
    }
  }

  render() {
    if (this.props.userPending !== false) {
      return <SplashScreen/>;
    }

    const isAuthenticated = this.props.userLogin !== null;

    return (
      <Provider store={ this.props.store }>
        <div className='app-root'>
          <div className={ 'app-root__workspace' + (isAuthenticated ? '' : ' is-preview') }>
            <Router history={ this.props.history } />
          </div>
          { isAuthenticated ? null : <LoginModal /> }
        </div>
      </Provider>
    );
  }
};

function mapStateToProps(state) {
  return {
    userPending: state.user.pending,
    userLogin: state.user.login,
    userLang: state.i18n.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch),
    redirect: bindActionCreators(redirect, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Root);
